export default __webpack_public_path__ + "static/media/B0006.8370aa47.png";